module.exports = __webpack_public_path__ + "static/media/2.580314b9.png";